var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pole-container"},[(_vm.poleSelectedNode.isLeaf)?[(_vm.currentPower && _vm.currentPower.protocol == 'baima')?_c('baiMaIndex',{staticClass:"content-item",attrs:{"power":_vm.currentPower}}):_c('baseIndex',{staticClass:"content-item",attrs:{"devices":_vm.devices}})]:_c('groupIndex',{attrs:{"devices":_vm.devices}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }